import { apiBaseURL, assetValueType, toastifyType } from "../../../constant";
import { setLoading } from "../loadingAction";
import apiConfig from '../../../config/apiConfig';
import { addTost } from "../toastAction";
import { metaDataAction } from "../metaDataAction";

export const assetValueAction = (filter, setDataLoad) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.post(apiBaseURL.ASSET_VALUE, filter);
        dispatch({ type: assetValueType.FETCH_ASSET_VALUE, payload: response.data.data });
        dispatch(metaDataAction({ pageSize: filter?.perPage, totalPages: response.data.data.totalPage, totalItems: response.data.data.totalRecords, currentPage: response.data.data.currentPage }))
        dispatch(setLoading(false));
        setDataLoad && setDataLoad(false)
    } catch (error) {
        dispatch(setLoading(false));
        setDataLoad && setDataLoad(false)
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    }
};


export const fetchAssetDetailsAction = (filter) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await apiConfig.post(apiBaseURL.ASSET_VALUE, filter);
        dispatch({ type: assetValueType.FETCH_ASSET_DETAILS_VALUE, payload: response.data.data });
        dispatch(metaDataAction({ pageSize: filter?.perPage, totalPages: response.data.data.totalPage, totalItems: response.data.data.totalRecords, currentPage: response.data.data.currentPage }))
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setLoading(false));
        dispatch(addTost({ type: toastifyType.SHOW_ERROR_MESSAGE, message: error?.response?.data?.message }));
    }
};